import React, { useContext } from "react"
import Offcanvas from "react-bootstrap/Offcanvas"
import "./offcanvasSidebar.css"
import Button from "react-bootstrap/Button"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBars } from "@fortawesome/free-solid-svg-icons"
import { sidebarContext } from "../../App"

function OffcanvasSidebar(props) {
  const handleClose = () => props.setShow(false)
  const handleShowSide = useContext(sidebarContext)

  return (
    <>
      <Button
        className='myBtn sidebar-btn'
        variant='primary'
        onClick={(e) => {
          e.currentTarget.blur()
          handleShowSide()
        }}>
        <FontAwesomeIcon icon={faBars} />
      </Button>

      <Offcanvas show={props.show} onHide={handleClose} placement='start'>
        <Offcanvas.Header closeButton>
          <Offcanvas.Title></Offcanvas.Title>
        </Offcanvas.Header>
        {props.children}
      </Offcanvas>
    </>
  )
}

export default OffcanvasSidebar
